import * as RequestStatusTypes from '../constants/RequestStatusTypes';
export const isPending = status => {
  return status === RequestStatusTypes.PENDING || status === RequestStatusTypes.STARTED;
};
export const isSucceeded = status => {
  return status === RequestStatusTypes.SUCCEEDED;
};
export const isFailed = status => {
  return status === RequestStatusTypes.FAILED;
};
export const isFulfilled = status => {
  return isSucceeded(status) || isFailed(status);
};
export const isUnfulfilled = status => {
  return !isFulfilled(status);
};